/**
 * Convert scalar property to a property object
 *
 * If property value is scalar and default key is specified, scalar value will
 * be written into the returned object's key.
 *
 * @param {*} prop property value
 * @param {string|false} key default key
 * @returns {object}
 */
const blockProperty = (prop, key = false) => {
    if (!prop) return {};

    const isObj = typeof prop == 'object'
               && !Array.isArray(prop);

    let obj = Object.assign({}, isObj ? prop : {});

    if (key && !isObj) obj[key] = prop;

    return obj;
};

module.exports = blockProperty;
